module.exports = __webpack_public_path__ + "static/media/texture (6).ba0063fa.jpg";